export default "__VITE_ASSET__vNq1wIRB__"